import { createIcon } from 'src/components/icons/icon-utils';

export const ScrollUpIcon = createIcon({
  path: 'M 3.19322 0.531362 C 3.5926 -0.01712 4.41063 -0.017121 4.81001 0.531362 L 7.54984 4.29406 C 8.03108 4.95497 7.55899 5.8827 6.74144 5.8827 L 1.26178 5.8827 C 0.444232 5.8827 -0.027854 4.95497 0.453388 4.29406 L 3.19322 0.531362 Z',
  viewBox: '0 0 8 6',
});
